import { render, staticRenderFns } from "./ConfirmAddDocumentTableModal.vue?vue&type=template&id=4a4458f1&scoped=true&"
import script from "./ConfirmAddDocumentTableModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAddDocumentTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4458f1",
  null
  
)

export default component.exports